import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Copy, ExternalLink } from 'lucide-react';
import type { TripLink } from './useDriverPlanPublications';

// Ukesplan-kolonnen «Liste»: kopier/åpne turens egen passasjerliste-lenke (/pl/). Kun aktiv når datoen er publisert til sjåfør/eksterne.
export function PassengerListLinkCell({ tripNumber, link }: { tripNumber: string; link?: TripLink }) {
  const { t } = useTranslation();
  if (!link || link.status !== 'active' || !link.url) {
    const label = link?.status === 'expired' ? t('driverPlanPublish.lenkeUtlopt', 'Utløpt') : t('customerPlanPublish.ikkePublisert', 'Ikke publisert');
    return <span className="text-[10px] italic text-muted-foreground whitespace-nowrap" data-testid={`weekly-pl-link-${tripNumber}`} data-state={link?.status || 'unpublished'}>{label}</span>;
  }
  const copy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try { await navigator.clipboard.writeText(link.url!); toast.success(t('driverPlanPublish.lenkeKopiert', 'Passasjerliste-lenke kopiert')); }
    catch { window.prompt(t('driverPlanPublish.kopierManuelt', 'Kopier lenken manuelt:'), link.url!); }
  };
  return (
    <span className="inline-flex items-center gap-0.5 whitespace-nowrap" data-testid={`weekly-pl-link-${tripNumber}`} data-state="active">
      <button type="button" onClick={copy} className="inline-flex items-center justify-center h-5 w-5 rounded text-violet-700 hover:bg-violet-100"
        title={t('driverPlanPublish.kopierLenke', 'Kopier passasjerliste-lenke')} data-testid={`weekly-pl-copy-${tripNumber}`}>
        <Copy className="w-3 h-3" />
      </button>
      <a href={link.url} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}
        className="inline-flex items-center justify-center h-5 w-5 rounded text-violet-700 hover:bg-violet-100"
        title={t('driverPlanPublish.apneLenke', 'Åpne passasjerlisten (slik sjåføren ser den)')} data-testid={`weekly-pl-open-${tripNumber}`}>
        <ExternalLink className="w-3 h-3" />
      </a>
    </span>
  );
}
